module.exports = __webpack_public_path__ + "static/media/sustainable-icon.9b30a588.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sustainable-icon.svg
// module id = 3259
// module chunks = 0